import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import "./styles.scss";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { MdClose } from "react-icons/md";

function SubMenuMobile({
	title,
	menuItems,
	activeMobileMenu,
	handleActiveMobileMenu,
}) {
	return (
		<div
			className="submenu-mobile"
			aria-hidden={activeMobileMenu === title ? "false" : "true"}
		>
			<div className="submenu-mobile__actions">
				<button
					className="btn btn--link submenu-mobile__action-button submenu-mobile__back"
					onClick={() => handleActiveMobileMenu("primary")}
				>
					<HiOutlineArrowNarrowLeft
						aria-hidden="true"
						size={24}
						className="submenu-mobile__back-arrow"
					/>{" "}
					Back
				</button>
				<button
					className="btn btn--reset submenu-mobile__action-button"
					onClick={() => handleActiveMobileMenu(null)}
				>
					<MdClose title={`Close Menu`} size={32} />
				</button>
			</div>
			<nav aria-label={`${title}-navigation`}>
				<ul className="submenu-mobile__items">
					{menuItems.map((subMenuItem, index) => (
						<li className="submenu-mobile__item" key={index}>
							<Link
								to={`/${subMenuItem.slug}`}
								className="submenu-mobile__link"
							>
								<div className="submenu-mobile__icon">
									<div
										dangerouslySetInnerHTML={{
											__html: subMenuItem.icon.svg.content,
										}}
									/>
								</div>
								<div className="submenu-mobile__content">
									<div className="submenu-mobile__heading">
										{subMenuItem.title}
									</div>
									<div>{subMenuItem.description}</div>
								</div>
							</Link>
						</li>
					))}
				</ul>
			</nav>
		</div>
	);
}

export default SubMenuMobile;

SubMenuMobile.propTypes = {
	title: PropTypes.string,
	menuItems: PropTypes.arrayOf(
		PropTypes.shape({
			contentful_id: PropTypes.string,
			description: PropTypes.string,
			icon: PropTypes.shape({
				svg: PropTypes.shape({
					content: PropTypes.string,
				}),
			}),
			slug: PropTypes.string,
			title: PropTypes.string,
		})
	),
	activeMobileMenu: PropTypes.string,
	handleActiveMobileMenu: PropTypes.func,
};
